module.exports = __webpack_public_path__ + "img/stone103.ed036a6b.png";